import React from 'react';
import { Category } from '../../types/category';
import styles from '../../styles/shared/CardGrid.module.css';

interface CategoryCardProps {
  category: Category;
  onEdit: (category: Category) => void;
  onDelete: (categoryId: number) => void;
}

const CategoryCard: React.FC<CategoryCardProps> = ({ category, onEdit, onDelete }) => {
  const categoryName = category.name || category.category_name;
  const imageUrl = category.image_url;

  return (
    <div className={styles.card}>
      <div className={styles.imageContainer}>
        {imageUrl ? (
          <img 
            src={imageUrl} 
            alt={categoryName}
            className={styles.cardImage}
            onError={(e) => {
              e.currentTarget.src = '/placeholder-category.jpg';
            }}
          />
        ) : (
          <div className={styles.placeholderImage}>
            <span>📁</span>
          </div>
        )}
      </div>
      
      <div className={styles.cardContent}>
        <h3 className={styles.cardTitle}>{categoryName}</h3>
        
        <div className={styles.cardActions}>
          <button 
            onClick={() => onEdit(category)} 
            className={`${styles.cardActionButton} ${styles.cardEditButton}`}
          >
            Edit
          </button>
          <button 
            onClick={() => onDelete(category.id)} 
            className={`${styles.cardActionButton} ${styles.cardDeleteButton}`}
          >
            Delete
          </button>
        </div>
      </div>
    </div>
  );
};

export default CategoryCard; 